<template>
	<quiz-loading-view v-if="!isQuizLoaded"></quiz-loading-view>
	<quiz-passed v-else-if="isQuizPassed"></quiz-passed>
	<template v-else-if="isQuizFailed">
		<quiz-retry v-if="isFailedAndHaveRetry"></quiz-retry>
		<quiz-failed v-else></quiz-failed>
	</template>
	<quiz-initiation v-else-if="isFirstTimeQuiz"></quiz-initiation>
	<quiz-question v-else-if="isQuizInProgress"></quiz-question>
	<div v-else>
		Unknown state
	</div>
</template>

<script lang="ts">
import QuizFailed from '@/components/quiz/main-screens/QuizFailed.vue'
import QuizInitiation from '@/components/quiz/main-screens/QuizInitiation.vue'
import QuizPassed from '@/components/quiz/main-screens/QuizPassed.vue'
import QuizQuestion from '@/components/quiz/main-screens/QuizQuestion.vue'
import QuizRetry from '@/components/quiz/main-screens/QuizRetry.vue'
import { QuizActions } from '@/store/modules/quiz/actions'
import { STATE_MODULES } from '@/store/state-modules'
import { SkillAssessmentQuizStatues } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'
import QuizLoadingView from './QuizLoadingView.vue'

export default defineComponent({
	name: "main-quiz-screen",
	mixins: [SkillAssessmentQuizStatues],
	components: {
		QuizFailed, QuizInitiation, QuizPassed, QuizQuestion, QuizRetry, QuizLoadingView
	},
	mounted () {
		this.$store.dispatch(`${STATE_MODULES.QUIZ}/${QuizActions.LOAD_QUIZ_MAPPING}`)
	}
})
</script>

<style scoped>

</style>
